import styles from "./vacation-affordability.module.css"

import React from "react"
import {Wizard} from "activities/components/wizard"

import * as shared from "activities/components/shared"
import * as affordability from "activities/calculators/affordability"

const VacationAffordabilityCalculator_ = shared.ActivityFactory(
  ({getProps, getState, updateState, setState, onReset}) => {
    const {resetKey, expenses, vacationCost, currentSavings, monthlyContribution, monthsToSave, colorClaims} = getState()
    const {steps, theme} = getProps()

    return (
      <div className={styles["wizard"]}>
        <Wizard
          resetKey={resetKey}
          onReset={onReset}
          setup={{
            steps,
            theme,
            props: {
              setState,
              updateState,
              expenses,
              vacationCost,
              currentSavings,
              monthlyContribution,
              monthsToSave,
              colorClaims
            }
          }}
        />
      </div>
    )
  },
  {
    defaultProps: {
      className: "vacation-affordability",
      steps: [
        {
          title: "Can You Afford a Vacation?",
          subtitle: "You’ve got your sights on the ideal vacation spot, now it’s time to start looking at finances. Fill in your expenses to see the total trip cost. ",
          details: {
            stepStyles: styles["step-one"],
            calloutStyles: styles["side-callout"],
            resultStyles: styles["side-stat"],
            selectionStyles: styles["selects"],
            colors: ["#FFBB00", "#64D254", "#C4A8DF", "#FF91B0", "#FF4444", "#6EC5EF", "#005F8B", "#00BDDC", "#65DFC5", "#9E6CC7"],
            expenseOptions: ["Airfare", "Accommodations", "Food", "Transportation", "Activities", "Shopping", "Child/Pet Care", "Passports/Visas", "Souvenirs", "Other"]
          },
          content: affordability.vacationExpenses,
          isStepComplete: () => true,
          buttonText: "Next"
        },
        {
          stepStyles: styles["step-two"],
          inputStyles: styles["inputs"],
          title: "Can You Afford a Vacation?",
          subtitle: "Give us a little information about your savings plan.",
          content: affordability.vacationSavings,
          isStepComplete: ({currentSavings, monthlyContribution, monthsToSave}) => currentSavings + monthlyContribution > 0 && monthsToSave > 0,
          buttonText: "Next"
        },
        {
          title: "Can You Afford a Vacation?",
          subtitle: "Let’s take a look at the results!",
          content: affordability.vacationResults,
          isStepComplete: () => true,
          details: {
            questionStyles: styles["question"],
            answerStyles: styles["answer"],
            resultStyles: styles["final-results"],
            statStyles: styles["large-stat"],
            calloutStyles: styles["large-callout"],
            results: [
              {
                answer: (diff) => `Pack your bags! You’ll have enough saved with ${diff} to spare.`
              },
              {
                answer: (diff) => `Sorry, not quite! You'll need to save ${diff} more for this trip.`
              }
            ]
          },
          buttonText: "Start Over"
        }
      ]
    },
    stateFilter: (state) => {
      const {expenses, vacationCost, currentSavings, monthlyContribution, monthsToSave} = state
      const totalSavings = currentSavings + monthlyContribution * monthsToSave

      return {
        expenses,
        vacationCost,
        currentSavings,
        monthlyContribution,
        monthsToSave,
        totalSavings
      }
    },
    defaultState: {
      colorClaims: [],
      expenses: [
        {name: "Accommodations", cost: 500},
        {name: "Food", cost: 300},
        {name: "Transportation", cost: 200},
        {name: "Activities", cost: 700},
        {name: "Souvenirs", cost: 150}
      ],
      vacationCost: null,
      currentSavings: null,
      monthlyContribution: null,
      monthsToSave: null
    }
  }
)

export default (props) => <VacationAffordabilityCalculator_ {...props} />
